<template lang="pug">
  v-container.pa-5
    div.h5.primary--text {{ $t('attach_prod.question') }}
    div.p1.basic700--text.mt-4 {{ $t('attach_prod.detail') }}

    //- ATTACH PRODUCT
    template(v-if="form.products && form.products.length > 0")
      v-select.mt-6(v-model="form.products" background-color="basic200" outlined dense hide-no-data chips hide-details multiple readonly :items="form.products" :menu-props="({'closeOnContentClick': false})" placeholder="Add Products" ref="selectProducts" type="button" append-icon="")
        template(v-slot:selection="{ attrs, item, select, selected }")
          v-chip.my-1.s2(outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close :color="item.status === 'draft' ? 'danger' : 'basic600'" :input-value="selected" @click:close="removeProduct(item)")
            span(v-if="item.name") {{ item.name.length > 25 ? (item.name.substr(0,25) + '...') : item.name }}{{ item.status === 'draft' ? ' (draft)' : '' }}
      
      v-btn.button-Aa-small.mt-2(color="info500" text x-small height="30" @click="showAttachProductsDialog = true")
        v-icon.mr-1(small) mdi-plus
        | {{ $t('add_product') }}
    
    div.d-flex.align-center.mt-6(v-else style="height: 40px; border:1px solid var(--v-basic400); border-radius: 4px;")
      v-btn.button-Aa-small(color="info500" text x-small height="30" @click="showAttachProductsDialog = true")
        v-icon.mr-1(small) mdi-plus
        | {{ $t('attach_product') }}

    //- SOLD OUT PRODUCTS
    div.s1.primary--text.mt-6 {{ $t('q1.question') }}
    div.mt-4(:style="form.hide_soldout_products ? activeBorder : inactiveBorder" @click="$set(form, 'hide_soldout_products', true)")
      div.s1.primary--text {{ $t('q1.yes') }}
    div.mt-3(:style="!form.hide_soldout_products ? activeBorder : inactiveBorder" @click="$set(form, 'hide_soldout_products', false)")
      div.s1.primary--text {{ $t('q1.no') }}

    //- INVENTORY QUANTITY
    div.s1.primary--text.mt-6 {{ $t('q2.question') }}
    div.p2.primary--text.mt-1 {{ $t('q2.detail') }}
    div.mt-4(:style="(!form.show_stock_level && !form.show_stock_level_when_low) ? activeBorder : inactiveBorder" @click="clickShowStock('hidden')")
      div.s1.primary--text {{ $t('q2.no_keep') }}
    div.mt-3(:style="(form.show_stock_level && !form.show_stock_level_when_low) ? activeBorder : inactiveBorder" @click="clickShowStock('always')")
      div.s1.primary--text {{ $t('q2.yes_always') }}
    div.mt-3(:style="(!form.show_stock_level && form.show_stock_level_when_low) ? activeBorder : inactiveBorder" @click="clickShowStock('low')")
      div.s1.primary--text {{ $t('q2.yes_only') }}

    .modals
      attach-products(v-if="showAttachProductsDialog" :open.sync="showAttachProductsDialog" :initialProducts.sync="form.products" excludeBundles)

</template>

<script>
import AttachProducts from '@/components/dialogs/AttachProducts.vue'

export default {
  name: 'ProductManagement',
  props: ['parentForm'],
  components: { AttachProducts },
  data: () => ({
    showAttachProductsDialog: false,
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)',
      padding: '16px'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '17px'
    }
  }),
  computed: {
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
  },
  methods: {
    removeProduct (item) {
      let index = this.form.products.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.form.products.splice(index, 1)
      this.$refs.selectProducts.isMenuActive = false
    },
    clickShowStock(value) {
      if (value === 'always') {
        this.$set(this.form, 'show_stock_level', true)
        this.$set(this.form, 'show_stock_level_when_low', false)
      } else if (value === 'low') {
        this.$set(this.form, 'show_stock_level', false)
        this.$set(this.form, 'show_stock_level_when_low', true)
      } else {
        this.$set(this.form, 'show_stock_level', false)
        this.$set(this.form, 'show_stock_level_when_low', false)
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "attach_prod": {
      "question": "What will you sell on this?",
      "detail": "These products will be displayed below your marketing content"
    },
    "add_product": "Add product",
    "attach_product": "Attach product",
    "q1": {
      "question": "Hide sold out products?",
      "yes": "Yes",
      "no": "No"
    },
    "q2": {
      "question": "Display products inventory quantity?",
      "detail": "Show customers the number of units left in stock.",
      "no_keep": "No, keep inventory hidden",
      "yes_always": "Yes, always show inventory",
      "yes_only": "Yes, but only when stock is low"
    }
  },
  "id": {
    "attach_prod": {
      "question": "Apa yang akan kamu jual pada halaman ini??",
      "detail": "Produk-produk ini akan ditampilkan di bawah konten pemasaran kamu"
    },
    "add_product": "Tambahkan produk",
    "attach_product": "Pilih produk",
    "q1": {
      "question": "Sembunyikan produk yang terjual habis??",
      "yes": "Ya",
      "no": "Tidak"
    },
    "q2": {
      "question": "Tampilkan jumlah stok produk yang tersedia??",
      "detail": "Tampilkan kepada pelanggan jumlah unit yang tersisa dalam stok.",
      "no_keep": "Tidak, selalu sembunyikan stok produk",
      "yes_always": "Ya, selalu tampilkan stok produk",
      "yes_only": "Ya, hanya ketika stok produk sedikit"
    }
  }
}
</i18n>